import React, { useState } from 'react';
import PropTypes from 'prop-types';
import LoginForm from '../../containers/loggedOut/Login/LoginForm';
import RegisterForm from '../../containers/loggedOut/SignUp/RegisterForm';
import DefaultLogin from '../../containers/loggedOut/Login/DefaultLogin';

function LoginSignUpContainer({ shouldOnlyToggle, publicPageLink, toggleLoginForm, isGuest, isGuestResgiter }) {
  const [showLoginForm, setShowLoginForm] = useState(false),
    [showSocialLogin, setShowSocialLogin] = useState((isGuest && isGuestResgiter) ? false : true),
    [showRegister, setShowRegister] = useState((isGuest && isGuestResgiter) ? true : false);

  const openLoginForm = () => {
    setShowLoginForm(true);
    setShowSocialLogin(false);
    setShowRegister(false);
  };

  const openSignUpForm = () => {
    setShowLoginForm(false);
    setShowSocialLogin(false);
    setShowRegister(true);
  };

  const openSocialLogin = () => {
    setShowLoginForm(false);
    setShowSocialLogin(true);
    setShowRegister(false);
  };

  return (
    <>
      {showLoginForm && (
        <LoginForm
          shouldOnlyToggle={shouldOnlyToggle}
          publicPageLink={publicPageLink}
          openLoginForm={openLoginForm}
          openSocialLogin={openSocialLogin}
          openSignUpForm={openSignUpForm}
          toggleLoginForm={toggleLoginForm}
        />
      )}
      {showRegister && (
        <RegisterForm
          shouldOnlyToggle={shouldOnlyToggle}
          publicPageLink={publicPageLink}
          openLoginForm={openLoginForm}
          openSocialLogin={openSocialLogin}
          openSignUpForm={openSignUpForm}
          toggleLoginForm={toggleLoginForm}
        />
      )}
      {showSocialLogin && (
        <DefaultLogin
          shouldOnlyToggle={shouldOnlyToggle}
          publicPageLink={publicPageLink}
          openLoginForm={openLoginForm}
          openSocialLogin={openSocialLogin}
          openSignUpForm={openSignUpForm}
          toggleLoginForm={toggleLoginForm}
        />
      )}
    </>
  );
}

LoginSignUpContainer.propTypes = {
  shouldOnlyToggle: PropTypes.bool,
  toggleLoginForm: PropTypes.func,
  publicPageLink: PropTypes.string,
};
export default LoginSignUpContainer;
